import { render, staticRenderFns } from "./ComposerImageWrap.vue?vue&type=template&id=33959faf&scoped=true"
import script from "./ComposerImageWrap.vue?vue&type=script&lang=js"
export * from "./ComposerImageWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33959faf",
  null
  
)

export default component.exports